import { Box, Grid2, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./index.scss";
import CustomModalBirthday from "./customModalBirthday";
import { checkNationalId } from "utils/checkNationalId";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetMyProfile, useValidateNationalId } from "hooks/user";
import LoadingButton from "@mui/lab/LoadingButton";
import CustomModalSuccess from "components/modalSuccses";
import useInfoContext from "hooks/useInfoContext";

const NationalId = () => {
  const navigate = useNavigate();
  const [national, setNational] = useState("");
  const [nationalIdAlert, setNationalIdAlert] = useState("");
  const [birthday, setBirthday] = useState();
  const [birthdayAlert, setBirthdayAlert] = useState("");
  const [openbirthday, setOpenbirthday] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [queryString, setQueryString] = useState("");
  const location = useLocation();
  const { mutate: validateNationalIdRequest, isLoading } =
    useValidateNationalId();
  const { mutate: getMyProfile, isLoading: loadingGetMyProfile } =
    useGetMyProfile();
  const { setUserInfo } = useInfoContext();

  const handleOpen = () => setOpenModalSuccess(true);
  const handleCloseModalSuccess = () => {
    getMyProfile(
      {},
      {
        onSuccess: ({ status, user }) => {
          if (status === "OK") {
            setOpenModalSuccess(false);
            setUserInfo(user);
            if (queryString === "?register-concert") {
              navigate("/accpecting-rules?registered");
            } else {
              navigate("/edit-account");
            }
          }
        },
        onError: (e) => {
          console.log(e);
        },
      }
    );
  };
  const handleSend = () => {
    let valid = true;
    if (!national) {
      setNationalIdAlert("پر کردن کد ملی الزامی است.");
      valid = false;
    }
    if (!birthday) {
      setBirthdayAlert("پر کردن تاریخ تولد الزامی است.");
      valid = false;
    }

    if (!checkNationalId(national)) {
      setNationalIdAlert("کد ملی خود را به درستی وارد کنید");
      valid = false;
    }

    if (valid) {
      // call api and navigate to route
      validateNationalIdRequest(
        {
          nationalId: national,
          birthDate: birthday,
        },
        {
          onSuccess: (response) => {
            if (response.status === "OK") {
              handleOpen();
            }
          },
          onError: (error) => {
            console.log("error!", error);
            if (error.response.data.status === "ERROR! NATIONAL ID EXISTS!") {
              setAlertText("کد ملی قبلا در سیستم ثبت شده");
            } else {
              setAlertText("اطلاعات وارد شده صحیح نیست");
            }
          },
        }
      );
    }
  };

  const handleNationalChange = (e) => {
    const value = e.target.value;
    setNational(value);
    if (value) {
      setNationalIdAlert("");
    }
  };

  const handleBirthdayChange = (e) => {
    setOpenbirthday(true);
  };

  const handleCloseBirthday = () => {
    setOpenbirthday(false);
  };

  useEffect(() => {
    setQueryString(location.search);
  }, [location.search]);

  return (
    <Grid2 container columns={12} className="parent-national-id">
      <Grid2 item size={{ xs: 12 }} className="national-id-wrapper">
        <CustomModalBirthday
          open={openbirthday}
          close={handleCloseBirthday}
          setBirthday={setBirthday}
        />
        <Box className="child-box">
          <Box className="main-wrapper-national">
            {!queryString && (
              <Box className="title-text">
                <Typography variant="h5">
                  جهت استفاده از تمام امکانات آکادمی آن نیاز به تکمیل فرایند
                  احراز هویت است.
                </Typography>
              </Box>
            )}
            <Box className="national-input">
              <Typography className="top-text">
                {queryString
                  ? "جهت رزرو بلیط ابتدا باید فرایند احراز هویت را تکمیل کنید"
                  : "کد ملی و تاریخ تولد خود را وارد کنید"}
              </Typography>
              <Box className="input-box">
                <input
                  type="text"
                  placeholder="کد ملی"
                  value={national}
                  onChange={handleNationalChange}
                  className={nationalIdAlert ? "error" : ""}
                  autoFocus
                  tabIndex={1}
                />
              </Box>

              <Box className="input-box">
                <input
                  type="text"
                  placeholder="تاریخ تولد"
                  value={birthday}
                  onClick={handleBirthdayChange}
                  className={birthdayAlert ? "error" : ""}
                  tabIndex={2}
                />
              </Box>
              <Box className="alert-text">
                {alertText && <span>{alertText}</span>}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="bottom-bar-national">
          <LoadingButton
            loading={isLoading}
            variant="contained"
            className="continue"
            onClick={handleSend}
            loadingPosition="end"
            sx={{ fontFamily: "IRANSANSWEB" }}
          >
            احراز هویت
          </LoadingButton>
        </Box>
      </Grid2>
      <CustomModalSuccess
        open={openModalSuccess}
        close={handleCloseModalSuccess}
        title="احراز هویت با موفقیت انجام شد"
        loadingButton={loadingGetMyProfile}
      />
    </Grid2>
  );
};

export default NationalId;
